/* eslint-disable eqeqeq */
import React, { Component } from "react";
import { HOST_URL, ROOT } from "../constants";
import i18n from "i18next";
import TempOrderErrorPopup from "../components/TempOrderErrorPopup";
import writeCookie from "../function/writeCookie";
import getCookie from "../function/getCookie";
import { Translation } from "react-i18next";
import "../css/Result.css";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { login, loginPopup, countryList } from "../models";
import urlReplace from "../function/replaceUrl";
import isUrlEn from "../function/isUrlEn";
import { setGAEvent } from "../function/setGAEvent";
import isArray from "../function/isArray";

class Result extends Component {
  state = {
    paymentData: {
      cartItems: []
    },
    ctId: "",
    showFail: false,
    lang: "zhTW"
  };
  async componentDidMount() {
    const { fetchUser, fetchCountryList, fetchMenuCountryList } = this.props;
    const url = window.location.href;
    /*先抓URL判斷語系*/
    isUrlEn(url);
    const ctId = new URL(url).searchParams.get("ctId");
    const lang =
      this.props.match.params.lang || getCookie("hk-emphasis-language"); //重整頁面先到cookie拿語系
    if (lang === "en") {
      i18n.changeLanguage("en");
      this.setState({
        lang: "en"
      });
      if (window.OneTrust) window.OneTrust.changeLanguage("en");
    } else {
      i18n.changeLanguage("zhTW"); //繁體
      this.setState({
        lang: "zhTW"
      });
    }
    this.fetchSuccInforData(ctId);
    fetchUser();
    fetchCountryList();
    fetchMenuCountryList();
  }

  fetchSuccInforData = async ctId => {
    try {
      const response = await fetch(
        `${HOST_URL}/shopping/v1/compositions/order-data/${ctId}`,
        {
          headers: {
            "content-type": "application/json"
          },
          credentials: "include"
        }
      );
      const data = await response.json();
      if (response.status == 200) {
        //GET 成功
        this.setState({
          paymentData: data
        });
        let transactionTotal = data.totalNetAmount;
        if (typeof data.totalNetAmount === "string") {
          transactionTotal = data.totalNetAmount
            .replace(/^HK\$/, "")
            .replace(/,/g, "");
        }

        // if (window.dataLayer) {
        //   window.dataLayer.push({
        //     transactionId: data.ctId,
        //     transactionTotal: parseInt(transactionTotal)
        //   });

        //   const cartItems = data.cartItems;
        //   const estimateDutyTax = data.estimateDutyTax ? Number(data.estimateDutyTax.replace(/^HK\$/, "").replace(/,/g, "")) : 0;
        //   const shippingFee = data.shippingFee ? Number(data.shippingFee.replace(/^HK\$/, "").replace(/,/g, "")) : 0;
        //   const total = data.totalDiscountAmount ? Number(data.totalDiscountAmount.replace(/^HK\$/, "").replace(/,/g, "")) : 0;
        //   const revenue = estimateDutyTax + shippingFee + total;
        //   const products = [];
        //   if (Array.isArray(cartItems)) {
        //     cartItems.forEach(item => {
        //       const obj = {};
        //       obj.name = item.information.prodname2;
        //       obj.id = item.information.code;
        //       obj.brand = item.information.prodname1;
        //       obj.price = item.discountAmount.replace(/^HK\$/, "").replace(/,/g, "");
        //       obj.quantity = item.quantity;
        //       products.push(obj);
        //     })
        //   }
        //   window.dataLayer.push({
        //     ecommerce: {
        //       purchase: {
        //         actionField: {
        //           id: data.ctId,
        //           revenue: revenue,
        //           tax: estimateDutyTax,
        //           shipping: shippingFee
        //         },
        //         products: products
        //       }
        //     }
        //   });
        // }

        //EC 795 - affiliate (Clickwise)
        let cookieAffiliateType = getCookie("affiliateType");
        let cookieClickwiseAffiliate = getCookie("CLICKVIEW_AFFILIATE");
        let cookieClickwiseExtraData = getCookie("CLICKVIEW_EXTRADATA");
        if (cookieAffiliateType === "clickwise" && cookieClickwiseAffiliate) {
          var clickwiseURL =
            "https://track.clickwise.net/pb?ActionCode=sale&TotalCost=" +
            transactionTotal +
            "&OrderId=" +
            data.ctId +
            "&CampaignID=9edf9a09&RefId=" +
            cookieClickwiseAffiliate +
            "&ExtraData=" +
            cookieClickwiseExtraData +
            "&Currency=HKD&ProductID=" +
            transactionTotal;
          console.log("clickwiseURL : " + clickwiseURL);
          const clickwiseResponse = await fetch(clickwiseURL, {
            mode: "no-cors"
          }); // call Clickwise
          console.log(clickwiseResponse);
        }

        const ipCountry = getCookie("utm_campaign");
        if (ipCountry) {
          this.postStylight(data);
        }
        writeCookie("purchase_emp", "Y", false, 30);
      } else {
        window.logApiErrors(
          "r",
          "fetchSuccInforData",
          response.status,
          response.statusText
        );
        this.setState({
          showFail: true
        });
        throw new Error("others-erroe-code");
      }
    } catch (err) {
      this.setState({
        showFail: true
      });
      console.log("error", err);
    }
  };

  closeShowFail = () => {
    const { lang } = this.state;
    const pathLang = lang === "en" ? "en" : "tc";
    this.setState({
      showFail: false
    });
    window.location.href = `${ROOT}/${pathLang}/checkout`;
  };

  transferDate = date => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = d.getMonth() + 1;
    const monthdate = d.getDate();
    if (this.state.lang === "zhTW") {
      return `${year}年${month}月${monthdate}日`;
    } else {
      return `${year}/${month}/${monthdate}`;
    }
  };

  handleClickLang(event) {
    const url = window.location.href;
    const ctId = new URL(url).searchParams.get("ctId");

    if (event.target.value === "en") {
      i18n.changeLanguage("en");
      writeCookie("eshop-hk-language", "en");
      this.setState({
        lang: "en"
      });
      /*塞en回url字串*/
      urlReplace(window.location.pathname, "tc", "en");
    } else {
      i18n.changeLanguage("zhTW"); //繁體
      writeCookie("eshop-hk-language", "zh_HK"); //香港網站
      this.setState({
        lang: "zhTW"
      });
      /*塞tc回url字串*/
      urlReplace(window.location.pathname, "en", "tc");
    }
    this.fetchSuccInforData(ctId);
    this.props.fetchMenuCountryList(); //切換語系, 取得貨幣menu英文國家列表
  }

  getCookie(t) {
    for (
      var r = t + "=", e = document.cookie.split(";"), i = 0;
      i < e.length;
      i++
    ) {
      for (var n = e[i]; " " == n.charAt(0); ) n = n.substring(1);
      if (0 == n.indexOf(r)) return n.substring(r.length, n.length);
    }
    return "";
  }

  sendPixel(t) {
    var r = this.getCookie("slid");
    if (r) {
      var e = "",
        i = "coi=" + r;
      for (var n in t)
        "propertyId" == n ? (e = t[n]) : (i += "&" + n + "=" + t[n]);
      new Image().src =
        "https://stats.ps.stylight.net/track/" + e + "/sl?" + i + "&src=1&v=1";
    }
  }

  postStylight = data => {
    let dry_run = true;
    if (process.env.REACT_APP_BUILD_ENV === "prod") {
      dry_run = false;
    }
    const productCodes = data.cartItems
      .map(data => data.information.code)
      .join("|");
    const utm_campaign = getCookie("utm_campaign");
    const propertyIdOptions = {
      uk: "ce05f8e686c498e8a38e5b38f8c23e64",
      au: "a2552175bd44ed96c115f6227f5d9351",
      us: "ea2e9888ab42a763d954e56cc302e67c",
      ca: "da71c6d3d684a4dd6a55f82732f23dbb"
    };
    let ta = 0;
    if (data.usdTotalNetAmount) {
      ta = data.usdTotalNetAmount.replace(/^US\$/, "").replace(/,/g, "");
    }
    if (propertyIdOptions[utm_campaign]) {
      const parameters = {
        propertyId: propertyIdOptions[utm_campaign],
        skus: productCodes,
        oi: data.ctId,
        ta: parseInt(ta),
        ic: data.quantity,
        c: "USD",
        dry_run
      };
      this.sendPixel(parameters);
    }
  };

  render() {
    const { paymentData, showFail, lang } = this.state;
    const {
      ctId,
      estimatedDeliveryDate,
      deliveryOption,
      deliveryOptionCode,
      estimateDutyTax,
      shippingFee,
      address1,
      address2,
      rcptName,
      rcptSl,
      rcptMobCtryCde,
      rcptMobNbr,
      quantity,
      paymentType,
      cartItems,
      country,
      province,
      city,
      orderDate,
      postCode,
      coupons
    } = paymentData;
    const pathLang = lang === "en" ? "en" : "tc";
    const description =
      pathLang === "en"
        ? "At EMPHASIS, we embrace different styles and looks, resonating with the tastes of women from all walks of life. Our original designs are more than pretty accessories. They are designed to complete your look and express your individuality. We live in a world that imposes expectations on beauty. Our logo, featuring the stylised outline of an unconventional crown, is a proud symbol of our mission to challenge these expectations and let your inner strength shine through. Crown the Beautiful You."
        : "EMPHASIS 的原創珠寶不僅精緻瑰麗，我們獨特多變的設計更能圓滿妳的妝容服飾，展露自我風格。妳我縱使身處受標準審美限制的大時代，但我們品牌標誌上象徵富棱角的后冠能賦予妳勇於衝破枷鎖的力量，讓妳盡情綻放自己的獨特個性，閃爍耀眼。冠冕女性之美。";

    return (
      <>
        <Helmet>
          <title>EMPHASIS</title>
          <meta name="description" content={description} />
        </Helmet>
        <div id="header"></div>
        {showFail && (
          <TempOrderErrorPopup
            text={
              <Translation>
                {t => <>{t("errorPopup.informationNotExist")}</>}
              </Translation>
            }
            closeTempOrderFailByOutOfStock={this.closeShowFail.bind(this)}
            isResultPage={true}
          />
        )}

        <div className="content-wrapper-wider content-wrapper-wider-media">
          <div className="breadcrumb_wrap d-none d-md-block">
            <a
              className="breadcrumb__link"
              href={this.state.lang === "en" ? "/en/home" : "/tc/home"}
            >
              <span>
                {" "}
                <Translation>{t => <>{t("successPage.home")}</>}</Translation>
              </span>
            </a>
            <a
              className="breadcrumb__link"
              href={`${ROOT}/${pathLang}/checkout`}
            >
              <span>
                {" "}
                <Translation>
                  {t => <>{t("successPage.shoppingBag")}</>}
                </Translation>
              </span>
            </a>
          </div>

          <p className="pageBigTitle">
            <Translation>{t => <>{t("successPage.checkout")}</>}</Translation>
          </p>

          <div className="checkout_result_wrap checkout_result_ok_wrap chectout_sect">
            {/* <p className="bigTitle">
              <Translation>
                {t => <>{t("successPage.successfulPayment")}</>}
              </Translation>
            </p> */}
            <p className="desc ">
              <Translation>
                {t => <>{t("successPage.yourOrderCompleted")}</>}
              </Translation>
              <Translation>
                {t => <>{t("successPage.theOrderSummaryFollows")}</>}
              </Translation>
            </p>

            <div className="subheadings_wrap clearfix d-none d-md-block">
              <div className="deliveryDetails_wrap">
                <div className="subheading">
                  <span className="itemTitle">
                    <Translation>
                      {t => <>{t("successPage.transactionNumber")}</>}
                    </Translation>
                  </span>
                  {ctId}
                </div>
              </div>
              <div className="orderDetails_wrap">
                <div className="subheading">
                  <span className="itemTitle">
                    <Translation>
                      {t => <>{t("successPage.transactionDate")}</>}
                    </Translation>
                  </span>
                  {/* {this.transferDate(orderDate)} 日期不處理，由後端處理*/}
                  {orderDate}
                </div>
              </div>
            </div>

            <div className="clearfix">
              <div className="deliveryDetails_wrap">
                <div className="subheading d-block d-md-none">
                  <Translation>
                    {t => <>{t("successPage.transactionNumber")}</>}
                  </Translation>
                  {ctId}
                </div>
                <div className="details_wrap">
                  <table className="details_table" style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <td className="estlimated-date-td">
                          <Translation>
                            {t => <>{t("successPage.shippingDate")}</>}
                          </Translation>
                        </td>
                        <td> {estimatedDeliveryDate}</td>
                      </tr>
                      <tr>
                        <td>
                          <Translation>
                            {t => <>{t("successPage.shippingMethod")}</>}
                          </Translation>
                        </td>
                        <td>{deliveryOption}</td>
                      </tr>
                      <tr>
                        <td>
                          {deliveryOptionCode === "BRCH_PICKUP" ? (
                            <Translation>
                              {t => <>{t("successPage.pickUpStore")}</>}
                            </Translation>
                          ) : (
                            <Translation>
                              {t => <>{t("successPage.shippingAddress")}</>}
                            </Translation>
                          )}
                        </td>
                        <td>
                          {lang === "zhTW" ? (
                            <>
                              {address1},{address2}
                              {address2 ? "," : ""}
                              {city},{province},{postCode ? `${postCode},` : ""}
                              {country}
                            </>
                          ) : (
                            <>
                              {address1},&nbsp;{address2}
                              {address2 ? ", " : ""}
                              {city},&nbsp;{province}
                              ,&nbsp;{country}
                            </>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <Translation>
                            {t => <>{t("successPage.contactName")}</>}
                          </Translation>
                        </td>
                        <td>
                          {lang === "zhTW" ? (
                            <>
                              {rcptName}
                              {rcptSl}
                            </>
                          ) : (
                            <>
                              {rcptSl} {rcptName}
                            </>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <Translation>
                            {t => <>{t("successPage.contactNumber")}</>}
                          </Translation>
                        </td>
                        <td>
                          {rcptMobCtryCde}
                          {rcptMobNbr}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="orderDetails_wrap">
                <div className="subheading d-block d-md-none">
                  <span className="itemTitle">
                    <Translation>
                      {t => <>{t("successPage.transactionDate")}</>}
                    </Translation>
                  </span>
                  {orderDate}
                </div>
                <div className="details_wrap">
                  <table className="details_table">
                    <tbody>
                      <tr>
                        <td>
                          <Translation>
                            {t => <>{t("successPage.numberOfTransactions")}</>}
                          </Translation>
                        </td>
                        <td>{quantity}</td>
                      </tr>
                      <tr>
                        <td>
                          <Translation>
                            {t => <>{t("successPage.subTotal")}</>}
                          </Translation>
                        </td>
                        <td>{paymentData.totalDiscountAmount}</td>
                      </tr>
                      <tr>
                        <td>
                          <Translation>
                            {t => <>{t("successPage.shippingCost")}</>}
                          </Translation>
                        </td>
                        <td>{shippingFee}</td>
                      </tr>

                      {paymentData.campaignAmount ? (
                        <tr>
                          <td>
                            <Translation>
                              {t => <>{t("successPage.promotion")}</>}
                            </Translation>
                            ({paymentData.campaignDescription})：
                          </td>
                          <td>{paymentData.campaignAmount}</td>
                        </tr>
                      ) : null}

                      {paymentData.couponAmount ? (
                        <tr>
                          <td>
                            <Translation>
                              {t => <>{t("successPage.coupons")}</>}
                            </Translation>
                          </td>
                          <td>{paymentData.couponAmount}</td>
                        </tr>
                      ) : null}

                      {estimateDutyTax === 0 ||
                      estimateDutyTax === "HK$0" ||
                      estimateDutyTax === "HK$0.00" ? null : (
                        <tr>
                          <td>
                            <Translation>
                              {t => <>{t("successPage.tariffFee")}</>}
                            </Translation>
                          </td>
                          <td>{estimateDutyTax}</td>
                        </tr>
                      )}

                      <tr>
                        <td>
                          <Translation>
                            {t => <>{t("successPage.transactionAmount")}</>}
                          </Translation>
                        </td>
                        <td>{paymentData.totalNetAmount}</td>
                      </tr>
                      <tr>
                        <td>
                          <Translation>
                            {t => <>{t("successPage.paymentMethod")}</>}
                          </Translation>
                        </td>
                        <td>{paymentType}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="pdts_wrap">
              <div className="subheading">
                <Translation>
                  {t => <>{t("successPage.orderProductInfor")}</>}
                </Translation>
              </div>
              {cartItems.length !== 0
                ? cartItems.map((item, index) => (
                    <div className="pdt_wrap" key={index}>
                      <div className="details_wrap clearfix">
                        <img
                          className="pdtThm float-left"
                          src={item.information.imageUrl}
                          alt={item.information.prodname1}
                        />

                        <table className="details_table float-right">
                          <tbody>
                            <tr>
                              <td>
                                <Translation>
                                  {t => <>{t("successPage.productName")}</>}
                                </Translation>
                              </td>
                              <td>
                                <span>
                                  {item.information.prodname1}{" "}
                                  {item.information.prodname2}
                                </span>
                              </td>
                              <td className="notes_td_wrap">
                                {/* <span className="notes">( 減價貨品 )</span> */}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <Translation>
                                  {t => <>{t("successPage.styleNumber")}</>}
                                </Translation>
                              </td>
                              <td>
                                <span> {item.information.code}</span>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <Translation>
                                  {t => <>{t("successPage.numberOfItems")}</>}
                                </Translation>
                              </td>
                              <td>{item.quantity}</td>
                              <td></td>
                            </tr>
                            {item.information.data.length > 0 &&
                            item.information.data[0].name !== null
                              ? item.information.data.map((text, i) => (
                                  <tr key={i}>
                                    <td> {text.name}：</td>
                                    <td>{text.value}</td>
                                    <td></td>
                                  </tr>
                                ))
                              : ""}
                            <tr>
                              <td>
                                <Translation>
                                  {t => <>{t("successPage.commodityPrice")}</>}
                                </Translation>
                              </td>
                              <td>
                                <div>
                                  {item.information.origPrice !==
                                  item.discountAmount ? (
                                    <>
                                      <span className="price">
                                        {item.discountAmount}
                                      </span>{" "}
                                      <span className="originalPrice">
                                        {item.information.origPrice}
                                      </span>
                                    </>
                                  ) : (
                                    <span className="price">
                                      {item.information.origPrice}
                                    </span>
                                  )}
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>{item.information.returnCondition}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ))
                : ""}
              {isArray(coupons) &&
                coupons.map(
                  (item, index) =>
                    item.giftIndicator && (
                      <div key={index} className="pdt_wrap">
                        <div className="details_wrap clearfix">
                          <img
                            className="pdtThm float-left"
                            src={item.imageUrl}
                            alt=""
                          />
                          <table className="details_table float-right">
                            <tbody>
                              <tr>
                                <td>
                                  <Translation>
                                    {t => <>{t("successPage.productName")}</>}
                                  </Translation>
                                </td>
                                <td>{item.couponName}</td>
                                <td className="notes_td_wrap"></td>
                              </tr>
                              <tr>
                                <td>
                                  <Translation>
                                    {t => <>{t("successPage.numberOfItems")}</>}
                                  </Translation>
                                </td>
                                <td>1</td>
                              </tr>
                              <tr>
                                <td>
                                  <Translation>
                                    {t => (
                                      <>{t("successPage.commodityPrice")}</>
                                    )}
                                  </Translation>
                                </td>
                                <td>
                                  <span className="price">
                                    <Translation>
                                      {t => <>{t("checkout.couponFree")}</>}
                                    </Translation>
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <Translation>
                                    {t => <>{t("checkout.couponTnc")}</>}
                                  </Translation>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )
                )}
            </div>
            <p className="desc">
              <Translation>
                {t => <>{t("successPage.needAssistance")}</>}
              </Translation>
              <Translation>
                {t => <>{t("successPage.pleaseContactOurOfficer")}</>}
              </Translation>
            </p>

            <p className="contact">
              <Translation>{t => <>{t("successPage.hotline")}</>}</Translation>
              ：<a href="tele:＋852 2192 3228">+852 2192 3228</a>
            </p>

            <p className="contact">
              <Translation>
                {t => <>{t("successPage.contactEmail")}</>}
              </Translation>
              ：
              <a className="text-gold" href="mailto:eshop@emphasis.com">
                eshop@emphasis.com
              </a>
            </p>

            <p className="complete_btn_wrap">
              <a
                href={`${lang === "zhTW" ? "/tc" : "/en"}/home`}
                className="blockBtn"
              >
                <Translation>
                  {t => <>{t("successPage.complete")}</>}
                </Translation>
              </a>
            </p>
          </div>
        </div>
        <footer id="footer"></footer>
      </>
    );
  }
}

const mapDispatchToProps = () => {
  return {
    fetchMenuCountryList: () => countryList.actions.fetchMenuCountryList(),
    fetchUser: () => login.actions.fetchUser(),
    showLoginPopup: bool => loginPopup.actions.showLoginPopup(bool),
    fetchCountryList: () => countryList.actions.fetchCountryList(),
    fetchDutyTax: countryCode => countryList.actions.fetchDutyTax(countryCode)
  };
};
export default connect(null, mapDispatchToProps)(Result);
